<!--
  종합현황판 컨텐츠 설정 팝업

  @since 2018-09-19
  @author mk.ko
-->

<template>
  <common-dialog v-model="isOpen"
                 ref="filterListDialog"
                 :checked="checked"
                 :confirmEvt="onConfirm"
                 :footerBtn="footerBtnList"
                 :content-css="{minWidth: '300px', minHeight: '379px'}"
                 :title-name="titleName"
                 :authForce="true"
                 @show="showAfter()"
  >
    <div class="content-group">
      <div class="contents-row">
        <div class="portlet">
          <data-table ref="columnTable"
                      :fields="columnFields"
                      height="214px"
                      :virtualScrolling="false"
                      :data="columnDatas"
                      :visibleHeader="true"
                      :fieldSortable="false"
                      class="bs bs-data-table bs-data-table-basic"
                      style="width: 100%"
          />
        </div>
      </div>
    </div>
  </common-dialog>
</template>

<script>
  import commonDialog from '~/components/popUp/LayoutModalPopUp'

  export default {
    name: 'setting-column-dialog',
    props: {
      contents: {
        type: Array,
        default () {
          return []
        }
      },
      id: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
      matchIdKey: {
        type: String,
        default: 'id'
      },
      matchNameKey: {
        type: String,
        default: 'name'
      },
      matchUseKey: {
        type: String,
        default: 'use'
      },
      autoConfirmHide: {
        type: Boolean,
        default: true
      },
      footerBtnList: {
        type: Array,
        default: () => ['confirm']
      }
    },
    components: {
      'common-dialog': commonDialog
    },
    data () {
      return {
        isContinuousSet: true,
        checked: false,
        isOpen: false,
        listData: [],
        selectedData: [],
        listType: 'default',
        isSearch: false,
        multiSelect: false
      }
    },
    computed: {
      titleName () {
        return this.title || this.$t('lr.log_filterPopup_settingColumn')
      },
      columnFields () {
        return [
          {
            name: this.matchUseKey,
            title: this.$t('cmn.used'),
            width: 40,
            align: 'center',
            type: 'quasar',
            itemTemplate: (value, item) => {
              let itemDisabled = false
              if (typeof item.disabled !== 'undefined') {
                itemDisabled = typeof item.disabled === 'function' ? item.disabled.call(this, item) : item.disabled
              }

              return {
                template: 'q-checkbox',
                type: 'item',
                data: {
                  authForce: true,
                  disabled: this.isReadOnly || itemDisabled,
                  class: 'bs bs-q-checkbox bs-q-checkbox-default'
                },
                methods: {
                  input: this.onInput
                }
              }
            }
          },
          {
            name: this.matchNameKey,
            width: 200,
            align: 'left',
            itemTemplate: (val, d) => {
              return (d.comHeaderTitle) ? d.comHeaderTitle + ' - ' + d[this.matchNameKey] : d[this.matchNameKey]
            }
          }
        ]
      },
      columnDatas () {
        try {
          return this.listData || []
        } catch (e) {
          return []
        }
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
      onInput (val, chgData) {
        const findIdx = _.findIndex(this.listData, (d) => { return chgData[this.matchIdKey] === d[this.matchIdKey] })
        this.listData[findIdx] = chgData
      },
      chgSelectData () {
        const selD = []
        _.forEach(this.listData, (d) => {
          if (d[this.matchUseKey]) {
            selD.push(d[this.matchIdKey])
          }
        })

        this.selectedData = selD
        return selD
      },
      onConfirm () {
        if (this.isContinuousSet) {
          this.isContinuousSet = false
          this.onSend()
        }
      },
      async onSend () {
        let selD = this.chgSelectData()
        if (selD.length === 0) {
          this.$alertPopUp.show(this.$t('cmn.msg_atLeastOneItem'))
          this.isContinuousSet = true
          return
        }

        this.$emit('apply', { selectedKeys: selD, listData: this.listData })
        if (this.autoConfirmHide) {
          this.hide()
        }
      },
      show () {
        if (_.get(this.contents, ['length'], 0) > 0) {
          this.listData = _.cloneDeep(this.contents)
          const checkData = []
          _.each(this.listData, (dd) => {
            dd[this.matchUseKey] = (dd[this.matchUseKey] === undefined) ? false : dd[this.matchUseKey]
            if (dd[this.matchUseKey]) checkData.push(dd[this.matchIdKey])
          })
          this.selectedData = checkData
        }
        this.isContinuousSet = true
        this.$refs.filterListDialog.show()
      },
      showAfter () {
        this.$refs.columnTable.render()
      },
      hide () {
        this.listData = []
        this.$refs.filterListDialog.hide()
      }
    },
    watch: {
      listData () {
        _.forEach(this.listData, (d) => {
          const idx = _.findIndex(this.selectedData, (sD) => { return sD === d[this.matchIdKey] })
          d[this.matchUseKey] = idx > -1
        })
      }
    }
  }
</script>

<style scoped>

</style>
